import { render, staticRenderFns } from "./RulesRuTinkoff.vue?vue&type=template&id=6db1b7df"
import script from "./RulesRuTinkoff.vue?vue&type=script&lang=js"
export * from "./RulesRuTinkoff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports